import styled from 'styled-components';

import {
  SubscriptionStatus,
} from '@gymcloud/core';

import {
  Flex,
  Text,
  SVG,
} from 'web-styled';

interface PlanItemProps {
  isActive?: boolean
  isSelected?: boolean
}

export const Container = styled(Flex).attrs<PlanItemProps>({
  width: '100%',
  align: 'center',
  justify: 'space-between',
})`
  border: 2px solid ${props => (props.isSelected ? '#343A3D' : '#cccccc')};
  padding: 30px 15px;
  border-radius: 5px;
  cursor: ${props => (props.isActive ? 'default' : 'pointer')};

  &:hover {
    border-color: #343A3D;
  }
`;

export const CircleIcon = styled(SVG.CheckCircleIcon).attrs<PlanItemProps>(
  props => props.isSelected ? {
    circleFill: props.theme.colors.primary,
    circleStroke: props.theme.colors.primary,
  } : props.isActive ? {
    circleFill: '#FFFFFF',
    checkStroke: props.theme.colors.primary,
    circleStroke: props.theme.colors.primary,
  } : {
    circleFill: '#FFFFFF',
    circleStroke: '#CCCCCC',
  },
)``;

type StatusProps = {
  status: SubscriptionStatus
};

export const Status = styled.div<StatusProps>`
  position: relative;
  padding: 5px 15px;
  color: #fff;
  text-align: center;
  text-transform: capitalize;
  border-radius: 7px;
  border: 1px solid  transparent;
  position: relative;
  top: 2px;

  ${(props) => {
    switch (props.status) {
      case 'active':
        return `
          color: ${props.theme.colors.success};
          border-color: ${props.theme.colors.success};
        `;
      case 'trialing':
        return `
          color: ${props.theme.colors.link};
          border-color: ${props.theme.colors.link};
        `;
      case 'past_due':
        return `
          color: #f0ad4e;
          border-color: #f0ad4e;
        `;
      case 'canceled':
        return `
          color: #343a3d;
          background: #efefef;
        `;
      default:
        return '';
    }
  }
  }
`;

export const PlanItemButton = styled(Text).attrs({
  as: 'button',
})`
  color: ${props => props.theme.colors.danger};
  cursor: pointer;
  background: none;
  border: none;
  outline: none;
  position: relative;
  top: 2px;

  &:hover {
    color: #23527C;
    text-decoration: underline;
  }
`;
